<template>
    <footer id="footer text-center">
        <div class="text-center text-dark">© Copyright by <a href="https://dworldsoftware.com" target="_blank">DWS</a>
        </div>
    </footer>
</template>

<script>
    export default{
        name: 'Footer',
        data(){
            return{

            }
        }
    }
</script>